import { schema } from "normalizr";
import AttachmentSchema from "./attachment";

export default new schema.Array(AttachmentSchema);
